import React from 'react';

import SignupContainer from './SignupContainer';
import ModalLayout from '../../components/layouts/ModalLayout/ModalLayout';
import stripeLogo from '../../assets/powered_by_stripe.svg';

const SignupModal = props => (
  <ModalLayout
    {...props}
    component={SignupContainer}
    links={[]}
    footer={
      <a
        href="https://stripe.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={stripeLogo} alt="Stripe logo" />
      </a>
    }
  />
);

export default SignupModal;



// WEBPACK FOOTER //
// ./src/features/Signup/SignupModal.js